import { createFileRoute } from '@tanstack/react-router';
import { AuthShell, STAFF_BRAND } from '../../../../components/AuthShell';
import { ForgotPasswordFlow } from '../../../../components/auth/forgot-password-flow';

export const Route = createFileRoute('/subdomain/admin/_auth/forgot-password')({
  component: () => (
    <AuthShell brand={STAFF_BRAND}>
      <ForgotPasswordFlow signInTo="/subdomain/admin/admin-login" />
    </AuthShell>
  ),
});
